<template>
    <div id="printable" class="form-elements order">
      <div class="row">
        <div class="flex xs12" >
          <va-card>
            <form>
              <div class="row mb-4">
                <div class="flex md6 xs12">
                  <p class="display-1">{{$t(editing ? 'shippingPrices.edit' : 'shippingPrices.new')}}</p>
                </div>
                <div class="flex md6 xs12" :style="{textAlign:'right'}">
                  <va-button icon="va-icon fa fa-save" @click.prevent="save"> {{ $t('catalog.product.saveProduct') }}</va-button>
                </div>
              </div>
              <div class="row">
                <div class="flex md9 sm12">
                  <div class="row">
                    <div class="flex md12 sm12">
                      <va-select
                        :label="$t('shippingPrices.type')"
                        v-model="fields.type.value"
                        textBy="description"
                        :options="fields.type.options"
                        :error="fields.type.error"
                      />

                    </div>
                    <div class="flex md6 sm12">
                      <va-input
                        v-model="fields.cartValue.value"
                        :placeholder="$t('shippingPrices.cartValue')"
                        :label="$t('shippingPrices.cartValue')"
                        :error="fields.cartValue.error"
                      />
                    </div>
                    <div class="flex md6 sm12">
                      <va-input
                        v-model="fields.price.value"
                        :placeholder="$t('shippingPrices.price')"
                        :label="$t('shippingPrices.price')"
                        :error="fields.price.error"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="flex-center loader" id="loader" :class="['flex-center','loader',{loading:loading}]">
              <spring-spinner
                  :animation-duration="2000"
                  :size="60"
                  :color="$themes.primary"
              />
            </div>
          </va-card>
        </div>
      </div>
      
    </div>
  </template>
  
  <script>
  import { SpringSpinner } from 'epic-spinners'
  
  export default {
    name: 'shipping-price',
    components:{
      SpringSpinner
    },
    data () {
      return {
        loading: false,
        fields : {
          type: {
            value: {}, 
            error: false, 
            required: true,
            options: [{ id: 'private', description: 'Privato' }, { id: 'company', description: 'Azienda' }]
          },
          cartValue: {value: null, error: false, required: true},
          price: {value: null, error: false, required: true},
        }
      }
    },
    computed:{
      editing(){
        return this.$route.params.uuid != 0
      }
    },
    created(){
      this.getShippingPrice();
    },
    methods: {
      getShippingPrice(){
        if(this.editing){
          this.$axios.get('api/shippingPrice/single',{ params: {uuid: this.$route.params.uuid }}).then(res => {
            this.fields.type.value = res.data.type;
            this.fields.cartValue.value = this.$normalizePrice(res.data.cartValue);
            this.fields.price.value = this.$normalizePrice(res.data.price);
          }).catch(err => {
            this.showToast(
              this.$t('system.genericError'),
                {
                  icon:'fa-warning',
                  position: 'bottom-right',
                  duration: 10000,
                  fullWidth: false,
                  className: 'vuestic-toast error'
                },
              )
          })
        }
      },
      save(){
        this.loading = true;
        if(this.evalFields()){

          const payload = {
            type: this.fields.type.value.id ? this.fields.type.value.id : this.fields.type.value,
            cartValue: this.$dbNormalizePrice(this.fields.cartValue.value),
            price: this.$dbNormalizePrice(this.fields.price.value)
          }
          if(!this.editing){
            this.$axios.post('api/shippingPrice/createRule',{
              payload: payload
            }).then(res => {
              this.loading = false;
              this.showToast(
                  this.$t('shippingPrice.successCreate'),
                  {
                      icon:'fa-check',
                      position: 'bottom-right',
                      duration: 10000,
                      fullWidth: false,
                      className: 'vuestic-toast'
                  },
              )
              this.$router.push('/admin/shipping-prices/'+res.data.uuid)
            }).catch(err => {
              this.loading = false;
              this.toastError('creationFailed');
            })
          }else{

            this.$axios.put('api/shippingPrice/updateRule',{
              uuid: this.$route.params.uuid,
              payload: payload
            }).then(res => {
              this.loading = false;
              this.showToast(
                  this.$t('shippingPrice.successUpdate'),
                  {
                      icon:'fa-check',
                      position: 'bottom-right',
                      duration: 10000,
                      fullWidth: false,
                      className: 'vuestic-toast'
                  },
              )

              this.getShippingPrice();
            }).catch(err => {
              this.loading = false;
              this.toastError('updateFailed')
            })

          }
        }else{
          this.toastError('mandatoryField');
          this.loading = false;
        }
      },
      evalFields(){
        var errors = 0;
        for(var i in this.fields){
          if(this.fields[i].required){
            if(!this.fields[i].value || this.fields[i].value == ''){
              errors = errors + 1;
              this.fields[i].error = true;
            }else{
              this.fields[i].error = false;
            }
          }
        }
        return errors == 0;
      },
      toastError(error){
            var msg = error ? error : 'genericError';
            this.showToast(
                this.$t('shippingPrices.errors.'+msg),
                {
                    icon:'fa-warning',
                    position: 'bottom-right',
                    duration: 10000,
                    fullWidth: false,
                    className: 'vuestic-toast error'
                },
            )
        },
    },
  }
  </script>
  
  <style>
  
  </style>